import { c as _c } from "react/compiler-runtime";
import { FFLogo } from "@repo/ui/components/brand/FFLogo";
import { Button } from "@repo/ui/components/ui/button";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Camera, Compass, Map, Search } from "lucide-react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Route = createFileRoute("/")({
  component: LandingPage
});
function LandingPage() {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx("div", {
      className: "mb-6 flex justify-center",
      children: /*#__PURE__*/_jsx(FFLogo, {
        variant: "full"
      })
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsxs("h1", {
      className: "mb-4 text-3xl font-bold tracking-tight text-gray-900 md:text-5xl",
      children: ["Tillg\xE4nglighetskartan", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
        className: "text-brand",
        children: "f\xF6r alla"
      })]
    });
    t2 = /*#__PURE__*/_jsx("p", {
      className: "mb-8 text-lg text-gray-600 md:text-xl",
      children: "Hitta tillg\xE4ngliga platser i din n\xE4rhet. Se entr\xE9er, d\xF6rrar och trappsteg \u2014 rapporterade av bes\xF6kare och analyserade med AI."
    });
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(Button, {
      size: "lg",
      className: "gap-2 bg-brand hover:bg-brand/90",
      asChild: true,
      children: /*#__PURE__*/_jsxs(Link, {
        to: "/karta",
        children: [/*#__PURE__*/_jsx(Map, {
          className: "h-5 w-5"
        }), "Utforska kartan"]
      })
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsx("section", {
      className: "relative overflow-hidden bg-gradient-to-b from-brand/5 to-white",
      children: /*#__PURE__*/_jsx("div", {
        className: "container mx-auto px-4 py-16 md:py-24",
        children: /*#__PURE__*/_jsxs("div", {
          className: "mx-auto max-w-2xl text-center",
          children: [t0, t1, t2, /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col justify-center gap-3 sm:flex-row",
            children: [t3, /*#__PURE__*/_jsx(Button, {
              size: "lg",
              variant: "outline",
              className: "gap-2",
              asChild: true,
              children: /*#__PURE__*/_jsxs(Link, {
                to: "/upptack",
                children: [/*#__PURE__*/_jsx(Compass, {
                  className: "h-5 w-5"
                }), "Uppt\xE4ck upplevelser"]
              })
            })]
          })]
        })
      })
    });
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx("h2", {
      className: "mb-10 text-center text-2xl font-bold text-gray-900",
      children: "S\xE5 fungerar det"
    });
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = /*#__PURE__*/_jsx(Step, {
      icon: /*#__PURE__*/_jsx(Camera, {
        className: "h-6 w-6"
      }),
      title: "Ta en bild",
      description: "Fotografera en entr\xE9. V\xE5r AI analyserar d\xF6rrbredd, tr\xF6skel, trappsteg och mer."
    });
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = /*#__PURE__*/_jsx(Step, {
      icon: /*#__PURE__*/_jsx(Search, {
        className: "h-6 w-6"
      }),
      title: "Granska",
      description: "Se AI-bed\xF6mningen och bekr\xE4fta. Admins verifierar innan publicering."
    });
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = /*#__PURE__*/_jsx("section", {
      className: "border-t bg-gray-50 py-16",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container mx-auto px-4",
        children: [t5, /*#__PURE__*/_jsxs("div", {
          className: "mx-auto grid max-w-3xl gap-8 md:grid-cols-3",
          children: [t6, t7, /*#__PURE__*/_jsx(Step, {
            icon: /*#__PURE__*/_jsx(Map, {
              className: "h-6 w-6"
            }),
            title: "Hj\xE4lp andra",
            description: "Din rapport syns p\xE5 kartan och hj\xE4lper andra hitta tillg\xE4ngliga platser."
          })]
        })]
      })
    });
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = /*#__PURE__*/_jsx("h2", {
      className: "mb-4 text-2xl font-bold text-gray-900",
      children: "Bidra till en mer tillg\xE4nglig stad"
    });
    t10 = /*#__PURE__*/_jsx("p", {
      className: "mx-auto mb-8 max-w-xl text-gray-600",
      children: "Varje rapport g\xF6r skillnad. Tillsammans kan vi kartl\xE4gga tillg\xE4ngligheten i hela Sverige \u2014 en entr\xE9 i taget."
    });
    $[9] = t10;
    $[10] = t9;
  } else {
    t10 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = /*#__PURE__*/_jsx("section", {
      className: "py-16",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container mx-auto px-4 text-center",
        children: [t9, t10, /*#__PURE__*/_jsx(Button, {
          size: "lg",
          className: "gap-2 bg-brand hover:bg-brand/90",
          asChild: true,
          children: /*#__PURE__*/_jsx(Link, {
            to: "/karta",
            children: "B\xF6rja nu \u2192"
          })
        })]
      })
    });
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = /*#__PURE__*/_jsxs("div", {
      className: "min-h-screen bg-white",
      children: [t4, t8, t11, /*#__PURE__*/_jsx("footer", {
        className: "border-t py-8 text-center text-sm text-gray-500",
        children: /*#__PURE__*/_jsxs("p", {
          children: ["\xA9 ", new Date().getFullYear(), " FasterForward. Alla r\xE4ttigheter f\xF6rbeh\xE5llna."]
        })
      })]
    });
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  return t12;
}
function Step(t0) {
  const $ = _c(10);
  const {
    icon,
    title,
    description
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = /*#__PURE__*/_jsx("div", {
      className: "mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-brand/10 text-brand",
      children: icon
    });
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = /*#__PURE__*/_jsx("h3", {
      className: "mb-1 font-semibold text-gray-900",
      children: title
    });
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = /*#__PURE__*/_jsx("p", {
      className: "text-sm text-gray-600",
      children: description
    });
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = /*#__PURE__*/_jsxs("div", {
      className: "text-center",
      children: [t1, t2, t3]
    });
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}